import { API } from '../../../../../api'
import { PageList } from '../../../utils'

import { QUERY } from './queries'

const List: PageList<API.membership_affiliates_index> = {
  queryKey: 'membershipAffiliates',
  query: QUERY,
}

export default List
